import { AxiosError } from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '../../../../../components/Modal';
import { backendErrorNotification, frontendNotification } from '../../../../../components/Notification';
import { orderApprovalGroupsApi } from '../../../../../services/requests';
import { OrderApprovalGroup } from '../../../../../types/apiResponse/orderApprovalGroup';

export type DeleteApprovalGroupProps = {
  selectedGroup: OrderApprovalGroup;
  closeModal: () => void;
  callback: () => void;
};

const DeleteApprovalGroupModal = ({ selectedGroup, closeModal, callback }: DeleteApprovalGroupProps) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const remove = async () => {
    setIsLoading(true);
    try {
      orderApprovalGroupsApi.query = '';
      await orderApprovalGroupsApi.delete(selectedGroup.id);
      frontendNotification({ message: t('success'), type: 'success' });
      callback();
      closeModal();
    } catch (err) {
      backendErrorNotification(err as AxiosError<any, any>);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      showModal
      title={t('deleteApprovalGroup') as string}
      closeModal={closeModal}
      cancelButton={closeModal}
      actionNameBtn={t('confirm') as string}
      action={remove}
      isLoading={isLoading}
      bodyStyle={{ paddingLeft: '1rem', paddingRight: '1rem', boxSizing: 'border-box' }}
    >
      <p>{t('deleteApprovalGroupSure')}</p>
      <p><strong>{t('description')}:</strong> {selectedGroup.description}</p>
    </Modal>
  );
};

export default DeleteApprovalGroupModal;
